'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _containers = require('../../containers');

var _common = require('../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var FlagContactButton = (_dec = (0, _mobxReact.inject)('UiStore', 'OptionsStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(FlagContactButton, _Component);

  function FlagContactButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FlagContactButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FlagContactButton.__proto__ || Object.getPrototypeOf(FlagContactButton)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'confirmDeleteShowing', _descriptor, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FlagContactButton, [{
    key: 'onToggleConfirmDelete',
    value: function onToggleConfirmDelete() {
      this.confirmDeleteShowing = !this.confirmDeleteShowing;
    }
  }, {
    key: 'onConfirmDelete',
    value: function onConfirmDelete() {
      this.props.onConfirmDeleteWarning();
      this.confirmDeleteShowing = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          UiStore = _props.UiStore,
          warningReasons = _props.OptionsStore.warningReasons,
          warning = _props.warning,
          canDeleteFlag = _props.canDeleteFlag,
          FlagButton = function FlagButton() {
        return _react2.default.createElement(
          _Button2.default,
          {
            className: 'flag',
            onClick: UiStore.modals.FlagContact.open
          },
          _react2.default.createElement(_common.Icon, { type: 'exclamation-triangle' }),
          ' FLAG'
        );
      },
          GuardedFlagButton = (0, _containers.createGuardedContainer)({
        enabledComponent: FlagButton,
        permissionName: 'parties.add_partywarning'
      });

      return _react2.default.createElement(
        'div',
        { className: 'flag-wrapper' },
        warning ? _react2.default.createElement(
          _Button2.default,
          {
            className: 'flag flagged',
            onClick: this.onToggleConfirmDelete,
            disabled: !canDeleteFlag
          },
          _react2.default.createElement(_common.Icon, { type: 'exclamation-triangle' }),
          ' ',
          warningReasons[warning.reason],
          canDeleteFlag && _react2.default.createElement(
            'span',
            { className: 'remove' },
            'Remove Flag'
          )
        ) : _react2.default.createElement(GuardedFlagButton, null),
        this.confirmDeleteShowing && _react2.default.createElement(_common.ConfirmDelete, {
          showConfirmDelete: true,
          message: 'Remove this flag?',
          confirmButtonText: 'Remove',
          onClickDelete: this.onConfirmDelete,
          onClickCancel: this.onToggleConfirmDelete
        })
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return FlagContactButton;
}(_react.Component), _class3.propTypes = {
  canDeleteFlag: _propTypes2.default.bool.isRequired,
  onConfirmDeleteWarning: _propTypes2.default.func.isRequired,
  OptionsStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired,
  warning: _propTypes2.default.shape({
    reason: _propTypes2.default.string
  })
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'confirmDeleteShowing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
})), _class2)) || _class) || _class) || _class);
var _default = FlagContactButton;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(FlagContactButton, 'FlagContactButton', '/app/src/components/page-contacts/FlagContactButton.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-contacts/FlagContactButton.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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